export const projects = [
  {
    title: "Aha.video Clone",
    subtitle: "Techstack used: HTML, CSS, JavaScript, React, Redux, Bootstrap",
    description:
      "Aha.video is an Indian subscription video on-demand and over-the-top streaming service which offers wide range over Telugu and Tamil-language content.",
    image: "./ahaAnim.gif",
    live: "https://ahavideoclone.vercel.app/",
    github:"https://github.com/priyaa74/aha-video-clone",
    addOns: "A collaborative project build by a team of 5 developers in 6 days.",
  },
  {
    title: "Tic-tac-toe with chat feature",
    subtitle: "Techstack used: HTML, CSS, JavaScript, React, NodeJS, ExpressJS, Stream-Chat, Stream-chat-react",
    description:
    "It is a multiplayer board game which also has functionality of online chat with your friends/opponents while playing the game. You can send the chat in real-time and also can react using emoticons.",
    image: "./multiplayer.gif",
    live: "https://tic-tac-toe-priyaa74.vercel.app/",
    github:"https://github.com/priyaa74/tic-tac-toe-with-chat",
    addOns: "An individual project build by me to implement the learnings.",
  },
  {
    title: "IndiaMart Clone",
    subtitle: "Techstack used: HTML, CSS, JavaScript, Local Storage",
    description:
      "India's largest and leading online platform which connects buyers and sellers. At IndiaMart any person can start selling their products in three simple easy steps.",
    image: "./indiamartAnim.gif",
    live: "https://astonishing-smakager-1c8cc9.netlify.app",
    github: "https://github.com/priyaa74/IndiaMart-Clone",
    addOns: "A collaborative project build by a team of 4 developers in 6 days.",
  },
  {
    title: "Overstock Clone",
    subtitle: "Techstack used: HTML, CSS, JavaScript, Local Storage, Rest API",
    description:
      "Overstock is an online retailer selling brand-name goods at best prices. Categories on the website range from furniture and rugs to apparel and jewellery.",
    image: "./stockOver.gif",
    live: "https://stockover-clone.netlify.app",
    github:"https://github.com/priyaa74/Decor-And-More",
    addOns: "A collaborative project build by a team of 3 developers in 5 days.",
  }
];



export const skills = [
  "HTML",
  "CSS",
  "Tailwind CSS",
  "Java",
  "JavaScript",
  "Rest API",
  "React",
  "Redux",
  "MongoDB",
  "Mongoose",
  "ExpressJS",
  "NodeJS",
  "Postman",
  "GitHub"
];
